
import 'whatwg-fetch'
import config from 'react-global-configuration';


const CreateUserActions = {

  validate(id,callback){
    fetch(config.get("API_PATH") + "/preusers/" + id , {
      method: "GET",
      headers: {
          'Content-Type': 'application/json'
      }
    }).then(function(response) {
      if(response.status === 200  ){
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
           return response.json()
         } else {
           return {"error":response.status}
        }
      }else if(response.status === 401){
        return {"error":401}
      }else if(response.status === 403){
        return  response.json()
      }else{
        throw new Error('Network response was not ok.');
      }
    }).then(function(data) {
       callback(data)
    })
  },

  create(mail, callback){
    const item = {mail:mail}
    fetch(config.get("API_PATH") + "/preusers" , {
      method: "POST",
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    }).then(function(response) {
      if(response.status === 200  ){
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
           return response.json()
         } else {
           return {"error":response.status}
        }
      }else if(response.status === 401){
        return {"error":401}
      }else if(response.status === 403){
        return  response.json()
      }else{
        throw new Error('Network response was not ok.');
      }
    }).then(function(data) {
       callback(data)
    })
  },

}

export default CreateUserActions
